/* Mobile drawer - Brands submenu: type-to-filter + "Show N more".
   Delegated on document so it works with the lazy-loaded drawer submenu content. */
(function () {
  if (window.__mblInit) return; window.__mblInit = true;

  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('[data-brand-search]');
    if (!input) return;
    var wrap = input.closest('.drawer-brands'); if (!wrap) return;
    var q = (input.value || '').trim().toLowerCase();
    var items = wrap.querySelectorAll('.drawer-brands__item');
    var more = wrap.querySelector('[data-brand-more]');
    if (q) {
      items.forEach(function (li) { li.hidden = li.getAttribute('data-brand').indexOf(q) === -1; });
      if (more) more.hidden = true;
    } else {
      // Clearing the search must not undo a "Show N more" the shopper already clicked,
      // so the collapsed state is restored only while the list is still collapsed.
      var expanded = wrap.classList.contains('is-expanded');
      items.forEach(function (li) { li.hidden = !expanded && li.classList.contains('is-extra'); });
      if (more) more.hidden = expanded;
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-brand-more]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.drawer-brands'); if (!wrap) return;
    wrap.classList.add('is-expanded');
    wrap.querySelectorAll('.drawer-brands__item.is-extra').forEach(function (li) { li.hidden = false; });
    btn.hidden = true;
  });
})();
